/* V2 幕素材已全部被 V5 的 v4/ 取代。此前票面导出还引用 V2 的成品票版，
   现已改用 v4 票版（见 src/lib/ticketLayout.ts），因此 src/assets/v2/ 下
   只剩这份幕清单本身；16 个幕素材常量也一并删除——Vite 不会摇掉
   new URL 资产引用，留着会让 dist 多打包约 5.5 MB 死素材。 */

/* V5「红船时代 · 新江南」：桌面与移动全部接入 P1 新图（v4/）。
   指向 webp 派生物而非 PNG 母版——母版留在仓库，用
   `npm run assets:webp` 重新生成；24 张合计 49.1 MB → 3.7 MB，
   否则每一幕都要在手机上拉 2 MB 的 PNG（dist 曾达 54.6 MB）。 */
const v4IntroDesktop = new URL("../v4/desktop/intro.webp", import.meta.url).href;
const v4QuestionDesktop = new URL("../v4/desktop/question.webp", import.meta.url).href;
const v4FirstDesktop = new URL("../v4/desktop/first.webp", import.meta.url).href;
const v4StruggleDesktop = new URL("../v4/desktop/struggle.webp", import.meta.url).href;
const v4DedicationDesktop = new URL("../v4/desktop/dedication.webp", import.meta.url).href;
const v4ReflectionDesktop = new URL("../v4/desktop/reflection.webp", import.meta.url).href;
const v4TheoryDesktop = new URL("../v4/desktop/theory.webp", import.meta.url).href;
const v4JiaxingDesktop = new URL("../v4/desktop/jiaxing.webp", import.meta.url).href;
const v4ActionDesktop = new URL("../v4/desktop/action.webp", import.meta.url).href;
const v4TicketDesktop = new URL("../v4/desktop/ticket.webp", import.meta.url).href;
const v4LightsDesktop = new URL("../v4/desktop/lights.webp", import.meta.url).href;
const v4EndDesktop = new URL("../v4/desktop/end.webp", import.meta.url).href;
const v4IntroMobile = new URL("../v4/mobile/intro.webp", import.meta.url).href;
const v4QuestionMobile = new URL("../v4/mobile/question.webp", import.meta.url).href;
const v4FirstMobile = new URL("../v4/mobile/first.webp", import.meta.url).href;
const v4StruggleMobile = new URL("../v4/mobile/struggle.webp", import.meta.url).href;
const v4DedicationMobile = new URL("../v4/mobile/dedication.webp", import.meta.url).href;
const v4ReflectionMobile = new URL("../v4/mobile/reflection.webp", import.meta.url).href;
const v4TheoryMobile = new URL("../v4/mobile/theory.webp", import.meta.url).href;
const v4JiaxingMobile = new URL("../v4/mobile/jiaxing.webp", import.meta.url).href;
const v4ActionMobile = new URL("../v4/mobile/action.webp", import.meta.url).href;
const v4TicketMobile = new URL("../v4/mobile/ticket.webp", import.meta.url).href;
const v4LightsMobile = new URL("../v4/mobile/lights.webp", import.meta.url).href;
const v4EndMobile = new URL("../v4/mobile/end.webp", import.meta.url).href;

export type SceneVisualKey = "intro" | "question" | "first" | "struggle" | "dedication" | "reflection" | "theory" | "jiaxing" | "action" | "ticket" | "lights" | "end";

export type SceneVisualAsset = {
  desktop: string;
  mobile: string;
  desktopPosition: string;
  mobilePosition: string;
};

export type SceneVisualManifest = Record<SceneVisualKey, SceneVisualAsset>;

export const sceneVisualManifest: SceneVisualManifest = {
  intro: { desktop: v4IntroDesktop, mobile: v4IntroMobile, desktopPosition: "center center", mobilePosition: "center center" },
  question: { desktop: v4QuestionDesktop, mobile: v4QuestionMobile, desktopPosition: "center center", mobilePosition: "center center" },
  first: { desktop: v4FirstDesktop, mobile: v4FirstMobile, desktopPosition: "center center", mobilePosition: "center center" },
  struggle: { desktop: v4StruggleDesktop, mobile: v4StruggleMobile, desktopPosition: "center center", mobilePosition: "center center" },
  dedication: { desktop: v4DedicationDesktop, mobile: v4DedicationMobile, desktopPosition: "center center", mobilePosition: "center center" },
  reflection: { desktop: v4ReflectionDesktop, mobile: v4ReflectionMobile, desktopPosition: "center center", mobilePosition: "center center" },
  theory: { desktop: v4TheoryDesktop, mobile: v4TheoryMobile, desktopPosition: "center center", mobilePosition: "center center" },
  jiaxing: { desktop: v4JiaxingDesktop, mobile: v4JiaxingMobile, desktopPosition: "center center", mobilePosition: "center center" },
  action: { desktop: v4ActionDesktop, mobile: v4ActionMobile, desktopPosition: "center center", mobilePosition: "center center" },
  ticket: { desktop: v4TicketDesktop, mobile: v4TicketMobile, desktopPosition: "center center", mobilePosition: "center center" },
  lights: { desktop: v4LightsDesktop, mobile: v4LightsMobile, desktopPosition: "center center", mobilePosition: "center center" },
  end: { desktop: v4EndDesktop, mobile: v4EndMobile, desktopPosition: "center center", mobilePosition: "center center" },
};
